<div class="modal-underground-parking" tabindex="0" cdkTrapFocus>
    <div class="underground-parking-card d-flex" matTooltip="Total plazas disponibles y plazas ocupadas">
        <div class="total-underground-spots d-flex fd-col align-items-center justify-content-center">

            <sit-icon [icon]="Icon.places" sizeClass="icon-size-48"></sit-icon>
            <span class="text-color-secondary-2">{{properties.totalSpotNumber}}</span>
            <span class="foo-icon">Plazas</span>
        </div>
        <div class="d-flex fd-col justify-content-center">
            <div
                class="underground-parking-status text-color-secondary-2 d-flex align-items-center justify-content-start d-row flex-grow ">
                <span class="available">{{properties.availableSpotNumber}}</span>
                <span>/</span>
                <span class="used">{{properties.occupiedSpotNumber}}</span>
            </div>
            <span class="subtitle">Plazas disponibles / plazas ocupadas</span>
        </div>
    </div>
</div>
